import React from 'react';
import PropTypes from 'prop-types';
import { wonSet } from '../../../utils';
import { position1winner, showMatchWinner, showOutcome } from '../../../utils/postScore';
import { WalkOverValues, RetiredValues, OutComeTypes, PlayerTypes } from '../../../utils/postScoreConstants';
import { titleCase } from '../../../utils/formatting';

const DisplayScore = (props) => {
    const { match, position, teamsDict, 'data-testid': dataTestId } = props;

    const getScores = (score, playerType) => {
        if (score && playerType) {
            const scoreArray = Object.values(score);
            if (scoreArray.length > 0) {
                return (
                    <React.Fragment>
                        {scoreArray.map((scoreItem, i) => {
                            return (
                                <div
                                    className={`score-item ${showMatchWinner(match.result?.outcome, match.result?.completionType) ? wonSet(scoreItem, playerType) ? PlayerTypes.WINNER : '' : ''}`}
                                    key={`score-item-${i}`}
                                    data-testid={dataTestId && `${dataTestId}.score-item-${i}`}
                                >
                                    {playerType === 'winner' ? scoreItem.winner ? scoreItem.winner : 0 : scoreItem.loser ? scoreItem.loser : 0}
                                    {(scoreItem.tiebreak != null && scoreItem.tiebreak >= 0) && (
                                        <sup>{playerType === 'winner' ? scoreItem.winnerTiebreak : scoreItem.tiebreak }</sup>
                                    )}
                                </div>
                            );
                        })}
                    </React.Fragment>
                );
            }

            if (playerType === 'loser' && (WalkOverValues.includes(match.result.outcome) || match.result.completionType === 'winnerdidnotstart') && showOutcome(match.result?.outcome)) {
                return (
                    <span className="outcome-font" data-testid={dataTestId && `${dataTestId}.outcome`}>{match.result.outcome ? titleCase(match.result.outcome) : 'Walkover'}</span>
                );
            }
        }
    };

    const isPosition1winner = position1winner(match, teamsDict);

    return (
        position === 'position1' ? (
            <div className="card-score-display position1" data-testid={dataTestId || undefined}>
                <div className="scores-container">
                    {isPosition1winner ? getScores(match.result.score, 'winner') : getScores(match.result.score, 'loser')}
                </div>
                <div className="winner-display-conatiner">
                    {isPosition1winner && showMatchWinner(match.result.outcome, match.result.completionType) && (
                        <div className="winning-scores" />
                    )}
                </div>
            </div>
        ) : (
            <>
                <div className="card-score-display mt8" data-testid={dataTestId || undefined}>
                    <div className="scores-container">
                        {isPosition1winner ? getScores(match.result.score, 'loser') : getScores(match.result.score, 'winner')}
                    </div>
                    <div className="winner-display-conatiner">
                        {!isPosition1winner && showMatchWinner(match.result.outcome, match.result.completionType) && (
                            <div className="winning-scores" />
                        )}
                    </div>
                </div>
                {/* display if retired after position2 score */}
                {(RetiredValues.includes(match.result.outcome) || match.result?.outcome === OutComeTypes.ABANDONED || match.result?.outcome === OutComeTypes.DOUBLEWALKOVER || match.result?.outcome === OutComeTypes.DEFAULTED || match.result?.outcome === OutComeTypes.WITHDREW) && (
                    <div className="text-right mt4 pr16" data-testid={dataTestId && `${dataTestId}.outcome`}>{match.result.outcome}</div>
                )}
            </>
        )
    );
};

DisplayScore.propTypes = {
    'data-testid': PropTypes.string,
};

DisplayScore.defaultProps = {
    'data-testid': null,
};

export default DisplayScore;
